import {errorActions} from "../ErrorHandler/errorHandler";
import {headers} from "../../../_metronic/_helpers";
import api from "../../util/api";

export const actionTypes = {
    getVideoInfo: "getVideoInfo",
    setIsLoading: "setIsLoading",
    getBadges: "getBadges",
    setIsLoadingBadges: "setIsLoadingBadges",
    getPeopleDropdown: "getPeopleDropdown",
    clearReviewPage: "clearReviewPage",
};

const initialReviewState = {
    // video data:
    videoReviewData: [],
    videoReviewDataError: {},
    isLoadingReviewData: false,
    //badges:
    badges: [],
    badgesError: {},
    isLoadingBadges: false,
    //people:
    peopleDropdown: [],
};

export const reviewReducer = (state = initialReviewState, action) => {
    switch (action.type) {
        case actionTypes.getVideoInfo: {
            const {videoReviewData, videoReviewDataError} = action.payload;
            return {...state, videoReviewData, videoReviewDataError};
        }

        case actionTypes.getBadges: {
            const {badges, badgesError} = action.payload;
            return {...state, badges, badgesError};
        }

        case actionTypes.getPeopleDropdown: {
            const {peopleDropdown} = action.payload;

            return {...state, peopleDropdown};
        }

        case actionTypes.setIsLoading: {
            const {isLoadingReviewData} = action.payload;

            return {...state, isLoadingReviewData};
        }

        case actionTypes.setIsLoadingBadges: {
            const {isLoadingBadges} = action.payload;
            return {...state, isLoadingBadges};
        }

        case actionTypes.clearReviewPage: {
            return {...initialReviewState};
        }

        default:
            return state;
    }
};

const reviewDataLoading = isLoadingReviewData => ({
    type: actionTypes.setIsLoading,
    payload: {
        isLoadingReviewData:isLoadingReviewData,
    },
});


export const reviewActions = {
    getVideoInfo: videoId => dispatch => {
        if (videoId) {
            dispatch(reviewDataLoading(true));
            return api
                .get(`v2/api/review/${videoId}`, {
                    method: "GET",
                    headers: headers(),
                })
                .then(({data: {data = {}, message = []}}) => {
                    dispatch(reviewDataLoading(false));

                    dispatch({
                        type: actionTypes.getVideoInfo,
                        payload: {
                            info: data,
                            videoInfoError: message && message[0],
                        },
                    });
                })
                .catch(err => {
                    console.error(err);
                    dispatch(reviewDataLoading(false));
                    dispatch(errorActions.setErrorMessage(err.message));
                });
        } else {
            dispatch(reviewDataLoading(false));
            dispatch(errorActions.setErrorMessage("Video ID not provided"));
        }
    },

    getBadges: (id, language) => dispatch => {
        return api
            .get(`v2/api/review/${id}/badges`, {
                method: "GET",
                params: {language},
                headers: headers(),
            })
            .then(({data: {data = [{}], message = [{}]}}) => {
                dispatch({
                    type: actionTypes.setIsLoadingBadges,
                    payload: {isLoadingBadges: false},
                });
                dispatch({
                    type: actionTypes.getBadges,
                    payload: {
                        badges: data,
                        badgesError: message[0].type ? message[0] : {},
                    },
                });
            })
            .catch(err => {
                dispatch({
                    type: actionTypes.setIsLoading,
                    payload: {isLoadingReviewData: false},
                });
                dispatch(errorActions.setErrorMessage(err.message));
            });
    },

    getPeopleDropdown: () => dispatch => {
        return api
            .get(`v2/api/review/speakers`, {
                method: "GET",
                headers: headers(),
            })
            .then(({data}) => {
                dispatch({
                    type: actionTypes.getPeopleDropdown,
                    payload: {
                        peopleDropdown: data.data || [],
                    },
                });
            })
            .catch(err => {
                console.error(err);

                return err;
            });
    },
    clearReviewPage: () => dispatch => dispatch({type: actionTypes.clearReviewPage, payload: null}),
};
